import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MainButton from '../MainButton/MainButton';
import Paragraph from '../Typography/Paragraph';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Don't show cookie banner on admin login page (old or new URL pattern)
    if (location.pathname === '/admin-login' || location.pathname.match(/^\/admin-access\/[a-zA-Z0-9]{32}$/)) {
      return;
    }

    // Check if user has already made a choice
    const cookieChoice = localStorage.getItem('cookieConsent');
    
    if (!cookieChoice) {
      // Show banner after 1 second delay
      const timer = setTimeout(() => {
        setIsVisible(true);
        // Add a small delay before animation starts
        setTimeout(() => {
          setIsAnimating(true);
        }, 50);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    handleClose();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    handleClose();
  };

  const handleClose = () => {
    setIsAnimating(false);
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
  };


  // Don't render on admin login page
  if (location.pathname === '/admin' || !isVisible) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-[9999] transform transition-transform duration-300 ease-in-out p-4 ${
      isAnimating ? 'translate-y-0' : 'translate-y-full'
    }`}>
      <div className="max-w-5xl mx-auto bg-white rounded-full p-4 pl-5 flex flex-col md:flex-row items-center gap-3 md:gap-4 shadow-lg border border-gray-200">
        <div className="flex-shrink-0 w-7 h-7 text-offblack flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none"/>
            <circle cx="8" cy="8" r="1" fill="currentColor"/>
            <circle cx="16" cy="8" r="1" fill="currentColor"/>
            <circle cx="8" cy="16" r="1" fill="currentColor"/>
            <circle cx="16" cy="16" r="1" fill="currentColor"/>
            <circle cx="12" cy="12" r="1" fill="currentColor"/>
            <path d="M18 6L16 8L18 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        </div>
        
        <div className="flex-1 flex items-center justify-center md:justify-start gap-2 text-center md:text-left">
          <Paragraph variant="MainParagraph" className="flex items-center">
            We use cookies to enhance your experience.
          </Paragraph>
        </div>
        
        <div className="flex gap-3 flex-shrink-0 w-full md:w-auto justify-center">
          <MainButton 
            variant="outlinesmall"
            onClick={handleReject}
          >
            Reject all
          </MainButton>
          <MainButton 
            variant="small"
            onClick={handleAccept}
          >
            Accept all
          </MainButton>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
